import { Drawer, Stack, Card, Text, TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons";
import { useState } from "react";
import NODE_TYPES from "./nodeTypes";

const WorkFlowNodesPanel = ({ opened, onClose, onAddNode, nodeTypes }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredNodes = NODE_TYPES.filter((nodeType) => {
    const searchLower = searchQuery.toLowerCase();
    return (
      nodeType.label.toLowerCase().includes(searchLower) ||
      nodeType.description.toLowerCase().includes(searchLower)
    );
  });

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      title="Add Node"
      position="right"
      size="xl"
      padding="md"
    >
      <Stack spacing="md">
        <TextInput
          placeholder="Search nodes..."
          icon={<IconSearch size={16} />}
          value={searchQuery}
          onChange={(event) => setSearchQuery(event.currentTarget.value)}
        />
        <div
          style={{
            height: "calc(100vh - 180px)",
            overflowY: "auto",
            paddingRight: "8px",
          }}
        >
          <Stack spacing="md">
            {filteredNodes.map((nodeType) => (
              <Card
                key={nodeType.type}
                shadow="sm"
                p="md"
                radius="md"
                withBorder
                style={{ cursor: "pointer" }}
                onClick={() => onAddNode(nodeType.type)}
              >
                <Stack spacing="xs">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    {nodeType.icon && <nodeType.icon size={20} />}
                    <Text weight={500}>{nodeType.label}</Text>
                  </div>
                  <Text size="sm" color="dimmed">
                    {nodeType.description}
                  </Text>
                </Stack>
              </Card>
            ))}
          </Stack>
        </div>
      </Stack>
    </Drawer>
  );
};

export default WorkFlowNodesPanel;
